export default "__VITE_ASSET__BuE1I2OT__"